/* globals Editor, location, history, gon, CountUp, getComputedStyle, getCookie, alert, prompt, setCookie */

'use strict'

window.Helpers || (window.Helpers = {})

Helpers.truncate = function (text, chars) {
  if (text) {
    if (chars === undefined) return text
    text = text.replace('&lt;', '<').replace('&gt;', '>')
    if (text.length <= chars) return text
    if (chars <= 0) return ''
    if (text && text.length > chars) return text.substring(0, chars) + '...'
  }
}

Helpers.forceModalHide = function () {
  $('.modal').modal('hide')
  $('body').removeClass('modal-open')
  $('.modal-backdrop').fadeOut('normal', function () {
    $('.modal-backdrop').remove()
  })
}

Helpers.manageActiveTabLink = function (element, anchor) {
  const hash = document.location.hash || anchor
  const pathname = document.location.pathname
  const tabLink = $(`a[href="${hash}"], a[href="${pathname}${hash}"], a[data-bs-target="${hash}"], button[data-bs-target="${hash}"]`)

  let stackLevel = 0
  const firstNavParent = (childElement) => {
    const possibleParent = childElement.parent()

    if (stackLevel > 5) {
      return null
    }
    if (possibleParent && possibleParent.hasClass('nav')) {
      return possibleParent
    }

    stackLevel++

    return firstNavParent(possibleParent)
  }

  const nav = firstNavParent(tabLink)

  const tabContent = $(nav?.find('.tab-content')[0] || nav?.parent().find('.tab-content')[0] || nav?.parent().parent().find('.tab-content')[0]).children('.tab-pane')

  if (tabContent.length > 0 && !document.location.hash.includes(tabContent[0].id)) {
    $(tabContent[0])?.removeClass('active')
    $(tabContent[0])?.removeClass('show')
  }

  tabLink.parent().addClass('active')
  tabLink.parent().siblings().removeClass('active').find('a').removeClass('active')
  tabLink.siblings().removeClass('active')
  $(window).trigger('resize')
}

Helpers.handleTabAnchors = function () {
  const params = new URLSearchParams(document.location.search)
  let anchor = document.location.hash || params.get('collection') || params.get('active_tab')
  const pathname = document.location.pathname

  if (anchor) {
    !anchor.includes('#') && (anchor = `#${anchor}`)
    // find and show active tab from anchor
    try {
      const tabLink = $(`a[href="${anchor}"], a[href="${pathname}${anchor}"], a[data-bs-target="${anchor}"], button[data-bs-target="${anchor}"]`)
      // tabLink.parent().removeClass('active') // resolve conflicts with data-preloader=true
      tabLink.siblings().each((i, item) => $(item).removeClass('active show'))
      // A plain navigation link can share the same href/hash as a real tab trigger
      // without being one (e.g. the profile dropdown on the candidate edit page) -
      // calling .tab('show') on it throws, since Bootstrap expects a .nav/.list-group/
      // [role=tablist] ancestor to activate siblings in. Only consider matches that
      // actually have one.
      const isTabTrigger = (i, item) => $(item).closest('.list-group, .nav, [role="tablist"]').length > 0
      const validTabLinks = tabLink.filter(isTabTrigger)
      const tabEl = $(validTabLinks[validTabLinks.length - 1])
      // Activate parent tab if the anchor targets a nested sub-tab
      const subPane = $(anchor)[0]
      if (subPane) {
        const parentPaneEl = subPane.closest('.tab-content')?.parentElement
        if (parentPaneEl && parentPaneEl.classList.contains('tab-pane')) {
          const parentTabLink = $(`a[data-bs-target="#${parentPaneEl.id}"], button[data-bs-target="#${parentPaneEl.id}"]`)
            .filter(isTabTrigger)
          if (parentTabLink.length) parentTabLink.tab('show')
        }
      }
      if (tabEl.length) tabEl.tab('show')
      Helpers.manageActiveTabLink(null, anchor)
      updateUrlHashForPositionsFilter()
    } catch (error) {
      console.log(error)
    }
  } else {
    Helpers.initReadmore()
  }

  $(document).on('shown.bs.tab', 'a[data-bs-toggle="tab"]', function (e) {
    if ($(e.target).parents('.tab-content').length) return
    if ($(e.target).closest('[data-no-scroll-reset]').length) return
    Helpers.initReadmore()
    window.scrollTo(0, 0)
    updateUrlHashForPositionsFilter()
  })

  $(document).on('show.bs.tab', 'a[data-bs-toggle="tab"]', function (e) {
    if ($(e.target).closest('.commented_inputs').length) return

    const hash = e.target.hash || e.target.dataset.bsTarget
    history.replaceState(null, '', hash)
    Helpers.manageActiveTabLink()
  })

  function updateUrlHashForPositionsFilter () {
    try {
      const pageHash = document.location.hash
      const form = $('form.filter-profile')
      if (form.length) {
        const ref = form.attr('action').split('#')
        const originalAction = ref[0]
        // const _original_hash = ref[1]
        form.attr('action', originalAction + pageHash)
      }
    } catch (_error) { }
  };
}

Helpers.paramsObject = function () {
  const search = location.search.substring(1)
  if (search) { return JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}') } else { return {} }
}

Helpers.handleSearchId = function () {
  if (!gon.search_id) return
  const params = location.search.replace('?', '').split('&').reduce(function (s, c) {
    const t = c.split('=')
    s[t[0]] = t[1]
    return s
  }, {})
  params.search_id || (params.search_id = gon.search_id)
  for (const prop in params) {
    if (prop) {
      params[prop] = params[prop].replace('%5B', '[').replace('%5D', ']').replace('%21', '!')
    }
    if (params[prop] === null || params[prop] === undefined || prop === '' || params[prop] === '') {
      delete params[prop]
    }
  }
  const queryString = $.param(params).replace('%5B', '[').replace('%5D', ']')
  const url = location.protocol + '//' + location.host + location.pathname + '?' + queryString + location.hash
  return window.history.pushState(null, null, url)
}

Helpers.initHoverDropdowns = function (element) {
  $('.dropdown', element).each(function () {
    const dropdown = $(this).find('.dropdown-menu')
    if (!dropdown.html()) {
      dropdown.siblings('.dropdown-toggle').find('.caret').remove()
      dropdown.remove()
    }
  })
  $('[data-bs-toggle="hover-dropdown"]', element).click(function (e) {
    if (!$(this).attr('href')) e.preventDefault()
  })
  $('[data-bs-toggle="hover-dropdown"]', element).closest('.dropdown').hover(function () {
    $(this).addClass('open')
  }, function () {
    $(this).removeClass('open')
  })
}

const TOUCH_TAP_WINDOW_MS = 600
const DROPDOWN2POPOVER_NAMESPACE = '.dropdown2popover'

const pathWithoutHash = (href) => (href || '').split('#')[0]

const parentLinkItem = (toggleLink, submenu) => {
  const href = toggleLink.attr('href')
  if (!href || href === '#') return ''

  const alreadyListed = submenu.find('a').toArray().some(a => pathWithoutHash(a.getAttribute('href')) === pathWithoutHash(href))
  if (alreadyListed) return ''

  return $('<li></li>').append(toggleLink.clone().removeAttr('class'))[0].outerHTML
}

const closePopoversOnOutsideTap = (e) => {
  $('.dropdown-popover.popover-open').each(function () {
    const popover = document.getElementById(this.getAttribute('aria-describedby'))
    if (this.contains(e.target) || popover?.contains(e.target)) return

    $(this).removeClass('popover-open').popover('hide')
  })
}

Helpers.dropdown2popover = function (elements) {
  $(document).off(`click${DROPDOWN2POPOVER_NAMESPACE}`)
  if (window.matchMedia('(hover: none)').matches) {
    $(document).on(`click${DROPDOWN2POPOVER_NAMESPACE}`, closePopoversOnOutsideTap)
  }

  $(elements).each(function () {
    const dropdown = $(this).addClass('dropdown-popover')
    if (typeof dropdown.popover !== 'function') { return }

    const toggleLink = dropdown.children('a')
    const submenu = dropdown.find('.dropdown-menu')
    const isTouch = window.matchMedia('(hover: none)').matches
    const hasSubmenu = submenu.children().length > 0
    const content = isTouch && hasSubmenu ? parentLinkItem(toggleLink, submenu) + submenu.html() : submenu.html()
    dropdown.popover({
      container: 'body',
      html: true,
      content: content || '',
      placement: 'right',
      trigger: 'manual',
      // Turbo navigation can dispose this popover instance mid-transition (see
      // turbo:before-fetch-response in common.js); Bootstrap's dispose() nulls out
      // every instance property, so a still-queued fade-transition callback blows up
      // on `this._activeTrigger` afterwards. Disabling the animation makes show/hide
      // complete synchronously, so there's never a pending callback left to race.
      animation: false,
      template: '<div class="popover dropdown-popover" role="tooltip"><div class="popover-body dropdown-menu"></div></div>'
    })
    const showPopover = () => dropdown.data('popoverOpenedAt', Date.now()).addClass('popover-open').popover('show')
    const hidePopover = () => dropdown.removeClass('popover-open').popover('hide')

    dropdown.off(DROPDOWN2POPOVER_NAMESPACE)
    toggleLink.off(DROPDOWN2POPOVER_NAMESPACE)

    dropdown.on(`mouseenter${DROPDOWN2POPOVER_NAMESPACE}`, () => {
      if (!dropdown.hasClass('popover-open')) showPopover()
    })
    toggleLink.on(`click${DROPDOWN2POPOVER_NAMESPACE}`, (e) => {
      if (!isTouch || !hasSubmenu) return

      e.preventDefault()
      if (!dropdown.hasClass('popover-open')) {
        showPopover()
      } else if (Date.now() - dropdown.data('popoverOpenedAt') > TOUCH_TAP_WINDOW_MS) {
        hidePopover()
      }
    })
    dropdown.on(`inserted.bs.popover${DROPDOWN2POPOVER_NAMESPACE}`, (e) => {
      const popover = $(`#${e.target.attributes['aria-describedby'].value}`)
      // Set active tab inside popover
      Helpers.manageActiveTabLink(popover)
      // Event for popover mouseleave
      popover.on('mouseleave', (e) => {
        if (isTouch) return

        const id = e.delegateTarget.attributes.id.value
        const dropdown = $(`[aria-describedby="${id}"]`)
        if ($(e.relatedTarget).is(dropdown) || $(e.relatedTarget).parents('.dropdown').is(dropdown)) {
          // do not hide popover if it is related popover element
        } else {
          dropdown.removeClass('popover-open').popover('hide')
        }
      })
    })
    dropdown.on(`mouseleave${DROPDOWN2POPOVER_NAMESPACE}`, (e) => {
      if (isTouch) return

      const dropdown = $(e.delegateTarget)
      const ariaDescribedby = e.delegateTarget.attributes['aria-describedby']
      const popover = ariaDescribedby ? $(`#${ariaDescribedby.value}`) : null
      if ($(e.relatedTarget).is(popover) || $(e.relatedTarget).parents('.popover').is(popover)) {
        // do not hide popover if mouse over popover
      } else {
        dropdown.removeClass('popover-open').popover('hide')
      }
    })
  })
}

Helpers.initReadmore = function () {
  require('readmore-js')

  $('.readmore').each(function () {
    const $readmore = $(this)
    const height = parseFloat($readmore.css('min-height')) || 100 // avoid height = 0
    $readmore.readmore({
      heightMargin: 25,
      collapsedHeight: height,
      moreLink: '<a href="#" class="readmore-link collapsed"></a>',
      lessLink: '<a href="#" class="readmore-link"></a>',
      speed: 300
    })
  })
}

Helpers.initCollapsableTable = table =>
  $('tr.collapsable[data-name] > td:first-of-type', table).on('click', function () {
    const parent = $(this).parent()
    const dataAttr = parent.data('name')
    const children = $(`[data-parent='${dataAttr}']`)

    if (parent.hasClass('collapsed')) { // show
      children.show()
      parent.removeClass('collapsed').find('.expander').removeClass('collapsed')
    } else { // hide
      children.hide()
      parent.addClass('collapsed').find('.expander').addClass('collapsed')
    }
  })

Helpers.kaminari_per_page_count = function () {
  $('select.kaminari-per-page-count').select2({
    minimumResultsForSearch: -1
  })
  $('select.kaminari-per-page-count').on('change', function (e) {
    const currentUrl = window.location.href
    $.ajax({
      url: '/update_per_page_count',
      method: 'POST',
      data: {
        per_page: e.val
      },
      success: function success () {
        window.location.href = currentUrl
      }
    })
  })
}

Helpers.format_phones = function () {
  return $('[data-phone-formattable]').each(function () {
    const rawPhone = this.dataset.phoneNumber.trim()
    if (!rawPhone || rawPhone === '') return
    let phone = rawPhone.replace(/[^0-9xX#]/g, '')
    if (!phone || phone === '') {
      this.href = ''
    } else {
      if (rawPhone[0] === '+') {
        phone = '+' + phone
      }
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.href = 'tel:' + phone
      } else {
        return ''
        // return this.href = "tksuite:" + phone + "?call";
      }
    }
  })
}

Helpers.countUp = {
  init: function init (element) {
    const elements = element || $('[data-countUpTo]')
    return elements.each(function (i, el) {
      let countTo, counter
      if ($(el).data('countupto')) {
        countTo = parseFloat($(el).data('countupto'))
        counter = new CountUp(el, 0, countTo, 0, 3, {
          useEasing: true
        })
        counter.start()
        return $(el).data('countupto', false)
      }
    })
  }
}

Helpers.shortCount = function (count) {
  count = parseFloat(count)
  if (count > 999) {
    count = Math.round(count / 1000) + 'k'
  }
  return count
}

Helpers.initSubmitByEnter = function (form) {
  form = $(form).is('form') ? $(form) : $(form).find('form')
  form.on('keyup', '.form-control:focus, .select2-focusser, .select2-input', function (e) {
    if (e.keyCode === 13) {
      $(e.target.form).submit()
    }
  })
  form.on('keyup', function (e) {
    if (e.keyCode === 13) {
      $(e.currentTarget).submit()
    }
  })
}

Helpers.initAnchors = function (selector, offset) {
  const currentPageUrl = document.location.pathname
  $(selector).each(function () {
    const link = $(this)
    offset = offset || 50
    link.on('click', function (e) {
      const anchor = link.attr('href').split('#')[1]
      if (anchor && link.attr('href').split('#')[0] === currentPageUrl) {
        e.preventDefault()
        const element = $('#' + anchor)
        if (element.length) {
          $('html, body').animate({
            scrollTop: element.offset().top - offset
          })
        }
      }
    })
  })
}

Helpers.initLiquidTags = function () {
  // Sing click - copy to clipboard
  // Double click - insert to editor

  function showTooltip (el, title) {
    let tooltip = bootstrap.Tooltip.getInstance(el)

    if (!tooltip) {
      tooltip = new bootstrap.Tooltip(el, {
        title,
        html: true,
        trigger: 'manual',
        placement: 'right'
      })
    }

    tooltip.show()

    setTimeout(() => {
      const instance = bootstrap.Tooltip.getInstance(el)
      if (instance) {
        instance.dispose()
      }
    }, 3000)
  }

  const liquidTags = $('kbd')
  const doClickAction = function ($liquidTag) {
    $liquidTag.selectText()
    document.execCommand('copy')

    showTooltip($liquidTag[0], I18n.t('profile_templates.edit.copied_tooltip'))
  }

  const doDoubleClickAction = function ($liquidTag) {
    const editorElement = ($('textarea.last-interacted-editor').length ? $('textarea.last-interacted-editor') : $('textarea.editor, textarea.code-editor')).first()
    Editor.whenReady(editorElement).then((editor) => {
      if (editor) editor.selection.insertHTML($liquidTag.text())
    })

    showTooltip($liquidTag[0], I18n.t('profile_templates.edit.inserted_tooltip'))
  }

  const CLICK_DELAY = 300

  liquidTags
    .off('click.liquid dblclick.liquid')
    .on('click.liquid', function () {
      const $el = $(this)

      const existingTimer = $el.data('clickTimer')
      if (existingTimer) {
        clearTimeout(existingTimer)
      }

      const timer = setTimeout(() => {
        doClickAction($el)
        $el.removeData('clickTimer')
      }, CLICK_DELAY)

      $el.data('clickTimer', timer)
    })
    .on('dblclick.liquid', function () {
      const $el = $(this)

      const timer = $el.data('clickTimer')
      if (timer) {
        clearTimeout(timer)
        $el.removeData('clickTimer')
      }

      doDoubleClickAction($el)
    })
}

Helpers.toBoolean = function (value) {
  if (typeof (value) === 'string') {
    value = value.toLowerCase()
  }

  return [true, 'true', 1].indexOf(value) !== -1
}

Helpers.randomId = function () {
  return 'id' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

Helpers.getColorLightness = function (hex, invert = true) {
  hex = hex.replace(/^\s*#|\s*$/g, '')
  if (hex.length === 3) hex = hex.replace(/(.)/g, '$1$1') // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`

  const r = parseInt(hex.substr(0, 2), 16)
  const g = parseInt(hex.substr(2, 2), 16)
  const b = parseInt(hex.substr(4, 2), 16)
  if (invert) { return r + b + g < 550 ? 'light' : 'dark' }
  return r + b + g > 550 ? 'light' : 'dark'
}

Helpers.getEditorContent = function (element, type) {
  const innerHtml = element.innerHTML.replace(/<p[^>]*><\/p>/g, '')
  if (type === 'string') {
    return innerHtml
  } else {
    const style = `font-family: ${getComputedStyle(element).getPropertyValue('font-family')} !important`
    return `<span style="${style}">${innerHtml}</span>`
  }
}

Helpers.setCookie = function (cname, cvalue, exdays) {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

Helpers.getCookie = function (cname) {
  const name = cname + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

Helpers.checkCookie = function () {
  let user = getCookie('username')
  if (user !== '') {
    alert('Welcome again ' + user)
  } else {
    user = prompt('Please enter your name:', '')
    if (user !== '' && user != null) {
      setCookie('username', user, 365)
    }
  }
}

Helpers.isFunction = function (func) {
  return typeof func === 'function'
}

// Extended methods

String.prototype.capitalize = function () {
  return this.split('_').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join('')
}

Array.prototype.clone = function () {
  return this.slice(0)
}

$.fn.selectText = function () {
  let doc, element, range, selection
  doc = undefined
  element = undefined
  range = undefined
  selection = undefined
  doc = document
  element = this[0]
  range = undefined
  selection = undefined
  if (doc.body.createTextRange) {
    range = document.body.createTextRange()
    range.moveToElementText(element)
    range.select()
  } else if (window.getSelection) {
    selection = window.getSelection()
    range = document.createRange()
    range.selectNodeContents(element)
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

$.fn.toHtmlTags = function () {
  return this.each(function () {
    let html
    if ($(this).html()) {
      html = $(this).html().replace(/&lt;/g, '<').replace(/&gt;/g, '>')
      return $(this).html(html)
    }
  })
}

// Add deprecated functions to jQuery until
// 'inputmask' library is using these:
$.isFunction = Helpers.isFunction
$.isArray = Array.isArray

// generated table is using it:
$.isNumeric = (value) => {
  return !Array.isArray(value) &&
    value !== '' &&
    value !== null &&
    Number.isFinite(Number(value))
}
